'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormPage } from '@whitbread-eos/atoms/ui';
import { formatIBAssetsUrl, cn } from '@whitbread-eos/utils/server';
import { useWizardContext } from './useWizardContext';
export function WizardPage({ type = 'default', children, footer, formTitle, showBackButton = true, onBackClick, className }) {
    const { icons } = useWizardContext();
    const renderBody = ()=>{
        if (type === 'form') {
            return /*#__PURE__*/ _jsx(FormPage, {
                baseDataTestId: "wizard",
                title: formTitle,
                iconClassName: "px-2 py-3 max-w-[3rem]",
                backIcon: showBackButton ? formatIBAssetsUrl(icons['icon.arrow.left.purple']) : undefined,
                backHref: showBackButton ? '#' : undefined,
                className: cn(formStyle, className),
                onBackClick: onBackClick,
                children: children
            });
        }
        return /*#__PURE__*/ _jsx("div", {
            className: cn(bodyStyle, className),
            "data-testid": "wizard-page",
            children: children
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: containerStyle,
        children: [
            renderBody(),
            footer
        ]
    });
}
const containerStyle = 'flex flex-col grow';
const bodyStyle = 'grow bg-lightGrey5';
const formStyle = 'grow border-b-0';
